import { useAppSelector } from "./redux";
import { selectors } from "store/currentUser";

export const usePermissionCheck = () => {
  const permissions = useAppSelector(selectors.permissionsSelector);
  return (permission: string) => {
    return permissions.includes(permission);
  };
};
